// extracted by mini-css-extract-plugin
export var cancelButton = "_mp-5";
export var content = "_mp-3";
export var createButton = "_mp-6";
export var drawerContainer = "_mp-0";
export var footer = "_mp-2";
export var header = "_mp-1";
export var orderFormColumn = "_mp-4";